import { createContext, useContext, useState, type ReactNode } from 'react'
import { UpdateToast } from './UpdateToast'

/**
 * The one bottom-right toast stack, mounted once for the whole app (App.tsx) so every toast shares a place and
 * never overlaps another. Upload progress (lib/uploads.tsx) portals into the uploads slot; the new-version notice
 * sits under it, nearest the corner. The stack starts above the support launcher and the mobile tab bar.
 *
 * The dock itself ignores the pointer (its gaps must not swallow clicks on the page beneath); each card opts back
 * in. It is not a live region: each toast owns its own announcement.
 */
export const DOCK_CLASS =
  'pointer-events-none fixed bottom-[calc(5.5rem+env(safe-area-inset-bottom,0px))] right-5 z-[120] flex w-[min(92vw,22rem)] flex-col gap-2 print:hidden'

const UploadsSlot = createContext<HTMLElement | null>(null)

/** Where upload progress renders: the dock's uploads slot, or null outside the provider. */
export const useUploadsSlot = (): HTMLElement | null => useContext(UploadsSlot)

export function ToastDockProvider({ children }: { children: ReactNode }) {
  const [uploads, setUploads] = useState<HTMLDivElement | null>(null)
  return (
    <UploadsSlot.Provider value={uploads}>
      {children}
      <div className={DOCK_CLASS}>
        <div ref={setUploads} className="empty:hidden" />
        <UpdateToast />
      </div>
    </UploadsSlot.Provider>
  )
}
